export default __webpack_public_path__ + "static/media/views_icon.671f92e6.svg";